import Swiper from 'swiper/bundle'
import constants from '../lib/constants'

export default class {
  constructor(element) {
    if (!element) {
      return false
    }

    this.wrap = jQuery(element)
    this.slider = this.wrap.find('.s-steps__boxes__items')
    this.pagination = this.wrap.find('.swiper-pagination')
    this.swiper = null

    
    if (jQuery(window).width() < 1279) {
      this._iniSlider()
    }

    this._checkBreakpoint()

    jQuery(window).on('resize', () => {
      this._checkBreakpoint()
    })
  }

  _checkBreakpoint() {
    if (jQuery(window).width() < 1279) {
      if (this.swiper == null) {
        this._iniSlider()
      }
    } else if (this.swiper) {
      this.swiper.destroy(true, true)
      this.swiper = null
    }
  }

  _iniSlider() {
    this.swiper = new Swiper(this.slider[0], {
      spaceBetween: 20,
      autoplay: {
        delay: 4000,
      },
      pagination: {
        clickable: true,
        el: this.pagination[0],
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        780: {
          slidesPerView: 3,
        },
        1520: {
          slidesPerView: 'auto',
        },
      },
    })
  }
}
